$(document).ready(function(){
$(".btn--link.site-header__menu").on("click", function(){
  $(".devNav-wrapperBg").show(300);
  if ( $(this).hasClass('mobile-nav--open') ){
    $(".mobile-nav-wrapper").css("transform" , "translateX(-100%)");
  }else{
    $(".mobile-nav-wrapper").css("transform" , "translateX(0)");
  }
});

$(".mobile-nav__item .btn--link").on("click" , function(){
 $(this).toggleClass("devRotateIcon").next().toggleClass("activeDropdown").slideToggle(200);
});

$(".devCloseIcon .icon").click(function(){
  $(".devNav-wrapperBg").hide(300);
});

$(".mobile-nav .mobile-nav__item .btn--link").on("mouseover" , function(){
  $(this).css("color", "#e4604a");
});

$(".mobile-nav>.mobile-nav__item").on("mouseleave" , function(){
  $(".mobile-nav .mobile-nav__item .btn--link").css("color", "#2d291f");
});

});